import { createContext, useContext } from "react";

import { StatisticsState } from "features/Statistics/types";

export const StatisticsContext = createContext<StatisticsState | null>(null);

export const useStatisticsContext = (): StatisticsState => {
    const state = useContext(StatisticsContext);

    if (!state) {
        throw new Error("useStatisticsContext должен использоваться внутри Statistics");
    }

    return state;
};
